import HttpServiceSingleton from '../HttpService/HttpService';
import { SUMMARY_PATH } from '../RulesService/constants';

const API_BASE = process.env.REACT_APP_RULES_API ?? '';

/**
 * Interface for individual KPI metric from API response
 */
export interface KpiMetric {
  count: number | string;
  label: string | null;
  delta: string;
}

/**
 * Interface for the complete KPI summary API response
 */
export interface KpiSummaryResponse {
  summary: {
    pendingRecommendations: KpiMetric;
    activeRules: KpiMetric;
    assignedAccess: KpiMetric;
    workforceTimeSaved: KpiMetric;
  };
}

/**
 * Service for KPI summary API operations
 */
const KpiSummaryService = {
  /**
   * Fetches KPI summary data from the API
   * @returns Promise with KPI summary response
   */
  getKpiSummary(): Promise<KpiSummaryResponse> {
    const url = `${API_BASE}${SUMMARY_PATH}`;

    return HttpServiceSingleton.get(url, {
      shouldThrowOnError: true,
    }) as Promise<KpiSummaryResponse>;
  },
};

export default KpiSummaryService;
